import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store';



Vue.use(Router)
import Inicio from '../components/inicio.vue';
import generarCFDI from '../components/generarCFDI.vue';
import obtenerDocs from '../components/obtenerDocumentos.vue';
import Reporte from '../components/reporte.vue';
import Login from '../components/login.vue';

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: "/",
      name: "inicio",
      component: Inicio,
    },
    {
      path: "/generarCFDI",
      name: "generador",
      component: generarCFDI,
      beforeEnter(to, from, next) {
        if (store.state.ticket) {
          next();
        } else next("/");
      }
    },
    {
      path: "/obtenerDocs",
      name: "obtenerDocs",
      component: obtenerDocs,
      beforeEnter(to, from, next) {
        if (store.state.ticket) {
          next();
        } else next("/");
      }
    },
    {
      path: "/reporte",
      name: "Reporte",
      component: Reporte,
      beforeEnter(to, from, next) {
        if (store.state.token) {
          next();
        } else next("/");
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    }
  ]
})